import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'

interface SpinnerProps extends CircularProgressProps {
  centered?: boolean
}

const Spinner = ({ centered = false, size }: SpinnerProps) => {
  return (
    <CircularProgress
      size={size}
      sx={{
        ...(centered && {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }),
      }}
    />
  )
}

export default Spinner
